import { Injectable, signal } from '@angular/core'

export type ModalType = 'warning' | 'error' | 'success' | 'info'

export interface ModalConfig {
  title: string
  message: string
  type: ModalType
  confirmText?: string
  cancelText?: string
  showInput?: boolean
  inputPlaceholder?: string
  inputValue?: string
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmationModalService {
  private isOpen = signal<boolean>(false)
  private modalConfig = signal<ModalConfig | null>(null)
  private resolveCallback: ((value: boolean | string) => void) | null = null
  private inputValue = signal<string>('')

  getIsOpen = this.isOpen.asReadonly()
  getModalConfig = this.modalConfig.asReadonly()
  getInputValue = this.inputValue.asReadonly()

  confirm(config: ModalConfig): Promise<boolean | string> {
    this.modalConfig.set({
      ...config,
      confirmText: config.confirmText || 'Confirm',
      cancelText: config.cancelText || 'Cancel',
      inputPlaceholder: config.inputPlaceholder || 'Enter name...',
    })
    this.inputValue.set(config.inputValue || '')
    this.isOpen.set(true)

    return new Promise<boolean | string>(resolve => {
      this.resolveCallback = resolve
    })
  }

  setInputValue(value: string): void {
    this.inputValue.set(value)
  }

  close(confirmed: boolean): void {
    this.isOpen.set(false)
    if (this.resolveCallback) {
      const config = this.modalConfig()
      if (confirmed && config?.showInput) {
        this.resolveCallback(this.inputValue())
      } else {
        this.resolveCallback(confirmed)
      }
      this.resolveCallback = null
    }
    setTimeout(() => {
      this.modalConfig.set(null)
      this.inputValue.set('')
    }, 300)
  }
}
